import classNames from 'classnames';
import React, { JSX, useMemo } from 'react';

export enum SpinnerSize {
  Small,
  Medium,
  Large,
  '2xlarge',
  '3xlarge',
}

interface Props {
  className?: string;
  inverseColor?: boolean;
  size?: SpinnerSize;
}

export default function Spinner({ size = SpinnerSize.Medium, inverseColor = false, className }: Props): JSX.Element {
  const parsedSizeClasses = useMemo(() => {
    switch (size) {
      case SpinnerSize.Small:
        return 'w-2 h-2';
      case SpinnerSize.Medium:
        return 'w-4 h-4';
      case SpinnerSize.Large:
        return 'w-7 h-7';
      case SpinnerSize['2xlarge']:
        return 'w-14 h-14';
      case SpinnerSize['3xlarge']:
        return 'w-20 h-20';
      default:
        return 'w-5 h-5';
    }
  }, [size]);

  return (
    <svg
      className={classNames(
        'animate-spin',
        parsedSizeClasses,
        {
          'text-white': !inverseColor,
          'text-gray-400': inverseColor,
        },
        className,
      )}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
    >
      <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' />
      <path
        className='opacity-75'
        fill='currentColor'
        d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
      />
    </svg>
  );
}
